import { useQuery } from '@tanstack/react-query';
import services from 'services/services';

/**
 * Query hook to fetch custom data columns (panel properties) for the current account.
 *
 * @param {Object} [options] - Optional react-query options
 */
export function useCustomDataColumnsQuery(options = {}) {
    return useQuery({
        queryKey: ['custom-data-columns'],
        queryFn: () => services.getCustomDataColumnsXHR(),
        ...options
    });
}
